import { useProvider } from "../../../../queries/use-provider";
import { getXtenantId } from "../../../../utils/utils";
import { RenderingProviderInfo } from "./claims/updateClaims/PatientDetailsSideSectionForClaim";
import { getRenderingProviderInfo } from "./billing-utils";

/**
 * Rendering Provider Details for the invoice screens + report. Name / Provider
 * ID come from the source record; NPI and License TX are read from the provider
 * record (getProviderById) since the encounter-codes endpoint omits them and the
 * saved superBill returns the license as null.
 */
export const useRenderingProviderInfo = (
  data: any
): RenderingProviderInfo | undefined => {
  const base = getRenderingProviderInfo(data);
  const { data: providerRes } = useProvider({
    providerUuid: base?.providerId,
    tenantId: getXtenantId(),
  });
  const provider = providerRes?.data;
  if (!base) return undefined;
  return {
    ...base,
    npi: base.npi ?? provider?.npi?.toString() ?? undefined,
    licenseNumber: base.licenseNumber ?? provider?.licenseNumber ?? undefined,
    taxonomyNumber: provider?.taxonomyNumber ?? undefined,
  };
};
